import { IMainPromoPin } from '../../types/newbuilding/mainPromoPin';
import { IApplicationState } from '../../types/redux';

export function getMainPromoPin(state: IApplicationState): IMainPromoPin | null {
  //На бэкенде ошиблись в тайпингах, после фикса можно убрать "as"
  return (state.newbuilding.mainPromoPin as IMainPromoPin) || null;
}
